import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const HeroContainer = styled.div`
  text-align: center;
  max-width: 800px;
  width: 100%;
`;

const Title = styled(motion.h1)`
  font-size: clamp(3rem, 8vw, 6rem);
  font-weight: 900;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #00d4ff, #8a2be2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 30px rgba(0, 212, 255, 0.5);
  line-height: 1.1;
`;

const Description = styled(motion.p)`
  font-size: clamp(1.1rem, 2.5vw, 1.5rem);
  margin-bottom: 3rem;
  color: #b8c5d1;
  line-height: 1.6;
  font-weight: 400;
`;

const PriceContainer = styled(motion.div)`
  margin-bottom: 3rem;
`;

const Price = styled.div`
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 900;
  color: #00d4ff;
  text-shadow: 
    0 0 20px rgba(0, 212, 255, 0.6),
    0 0 40px rgba(0, 212, 255, 0.4),
    0 0 60px rgba(0, 212, 255, 0.2);
  margin-bottom: 0.5rem;
`;

const PriceNote = styled.div`
  font-size: 1.2rem;
  color: #8a2be2;
  font-weight: 400;
`;

const CTAButton = styled(motion.button)`
  background: linear-gradient(135deg, #00d4ff, #8a2be2);
  color: #ffffff;
  font-size: clamp(1.1rem, 2vw, 1.3rem);
  font-weight: 700;
  padding: 1.2rem 3rem;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 
    0 8px 32px rgba(0, 212, 255, 0.3),
    0 4px 16px rgba(138, 43, 226, 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 12px 40px rgba(0, 212, 255, 0.4),
      0 6px 20px rgba(138, 43, 226, 0.4);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const GlowEffect = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(0, 212, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: pulse 3s ease-in-out infinite;
  z-index: -1;
  
  @keyframes pulse {
    0%, 100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.3; }
    50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.1; }
  }
`;

const Hero = () => {
  const handleCTAClick = () => {
    window.open('https://www.atom.com/name/spendy.ai', '_blank', 'noopener,noreferrer');
  };

  return (
    <HeroContainer>
      <GlowEffect />
      <Title
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Spendy.ai
      </Title>
      
      <Description
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        This premium domain is for sale! Perfect for AI-driven finance, budgeting, and spending assistants.
      </Description>
      
      <PriceContainer
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.6 }}
      >
        <Price>$10,000</Price>
        <PriceNote>Price negotiable</PriceNote>
      </PriceContainer>
      
      <CTAButton
        onClick={handleCTAClick}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.8 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Buy This Domain
      </CTAButton>
    </HeroContainer>
  );
};

export default Hero; 